import type { IUsernamePasswordAuthCmd } from "@/data/commands/auth/UsernamePasswordAuthCmd";
import { Validation } from "@/data/util/Validation";

import { FloatLabel } from "@/shared/ui/FloatLabel";
import { Ripple } from "@/shared/ui/Ripple";

import { Popup } from "@/components/dialog/Popup";

import { OperatorClient } from "@/operator/OperatorClient";
import { trans } from "@/operator/localization/Trans";

import { BaseController } from "./BaseController";

export class LoginController extends BaseController {
    private readonly $head: JQuery;
    private readonly $loginForm: JQuery;
    private readonly $loginBtn: JQuery;

    constructor() {
        super("login");

        this.$head = $(
            '<div class="head"><div class="logo">tastier</div><div class="title">Login</div></div>'
        ).appendTo(this.$view);

        const scrollable = $('<div class="scrollable" />').appendTo(this.$view);
        const centered = $('<div class="centered" />').appendTo(scrollable);

        centered.append('<div class="logo"><div class="icon" /></div>');
        centered.append('<div class="title">' + trans.login.title + "</div>");

        this.$loginForm = $('<form class="form login" />').appendTo(centered);
        this.$loginForm.submit((e) => {
            e.preventDefault();
            e.stopPropagation();

            this.onSubmit();

            return false;
        });

        let row = $('<div class="formrow" />').appendTo(this.$loginForm);
        row.append(
            '<div class="formcontrol intent"><label>' +
                trans.login.email +
                '</label><input type="text" name="username" /></div>'
        ).appendTo(row);

        row = $('<div class="formrow" />').appendTo(this.$loginForm);
        row.append(
            '<div class="formcontrol intent"><label>' +
                trans.login.password +
                '</label><input type="password" name="password" /></div>'
        ).appendTo(row);

        row = $('<div class="formrow" />').appendTo(this.$loginForm);
        this.$loginBtn = Ripple.bind(
            $('<button type="submit">' + trans.login.loginBtn + "</button>")
                .appendTo(row)
                .click(() => {
                    this.$loginForm.submit();
                })
        );

        FloatLabel.bind(this.$loginForm);
    }

    protected onBecomeVisible() {}

    protected onBecomeInvisible() {}

    private onSubmit() {
        if (this.$loginBtn.hasClass("loading")) return;

        const usernameField = this.$loginForm.find('input[name="username"]');
        const passwordField = this.$loginForm.find('input[name="password"]');

        const loginData: IUsernamePasswordAuthCmd = {
            userName: usernameField.val().length === 0 ? undefined : usernameField.val(),
            password: passwordField.val().length === 0 ? undefined : passwordField.val(),
        };

        let hasError = false;
        this.$loginForm.find(".has-error").removeClass("has-error");
        if (!Validation.isEmail(loginData.userName)) {
            hasError = true;
            usernameField.parent().addClass("has-error");
        }

        if (loginData.password === undefined || loginData.password.length < 3) {
            hasError = true;
            passwordField.parent().addClass("has-error");
        }

        if (hasError) return;

        this.$loginBtn.addClass("disabled").prop("disabled", true).addClass("loading");
        OperatorClient.context
            .authenticateWithCredentials(loginData)
            .then(() => {
                this.$loginBtn.removeClass("disabled").prop("disabled", false).removeClass("loading");
                
                //Reset password field
                passwordField.val('');
            })
            .catch(() => {
                this.$loginBtn.removeClass("disabled").prop("disabled", false).removeClass("loading");
                Popup.show({
                    title: trans.login.loginFailedTitle,
                    message: trans.login.loginFailedText,
                });
            });
    }
}
